import { ComponentProps } from 'react'
import { Search } from 'lucide-react'

/** Caja de búsqueda del kit (`dcc-input-wrap` con la lupa delante). `etiqueta` es su nombre accesible. */
export function Busqueda({ etiqueta, className, ...props }: Omit<ComponentProps<'input'>, 'type'> & { etiqueta: string }) {
  return (
    <div className={`dcc-input-wrap busqueda${className ? ` ${className}` : ''}`}>
      <Search className="dcc-lead dcc-i" aria-hidden />
      <input type="search" className="dcc-input dcc-has-lead" aria-label={etiqueta} {...props} />
    </div>
  )
}
